export const errorDataDetailModalTranslationEN = {
  ErrorDataDetailModal: {},
};
